var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.125 1.78125L6.375 4.78125C6.59375 5.28125 6.46875 5.875 6.03125 6.21875L4.5 7.5C5.53125 9.6875 7.3125 11.4688 9.5 12.5L10.7812 10.9688C11.125 10.5312 11.7188 10.4062 12.2188 10.625L15.2188 11.875C15.8125 12.0938 16.0938 12.75 15.9375 13.3438L15.1875 16.0938C15.0312 16.625 14.5625 17 14 17C6.25 17 0 10.75 0 3C0 2.4375 0.375 1.96875 0.90625 1.8125L3.65625 1.0625C4.25 0.90625 4.90625 1.1875 5.125 1.78125Z",
    fill: "#B0CCCF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMob);
export default __webpack_public_path__ + "static/media/mob.30b43cc9e2660f7953f93d924d18c818.svg";
export { ForwardRef as ReactComponent };